import Auth from "./Auth.js";
import Sidebar from "./sidebar.js";
import Migration from "./Migration.js";
import { combineReducers } from "redux";

export default combineReducers({ Auth, Sidebar, Migration });